import { formatLotStatus } from "@/utils/format.js";
import { LOT_STATUSES } from "@/utils/constants.js";
import FilterToolboxShell from "@/components/FilterToolboxShell.jsx";

export default function LotFilterToolbox({
    filters,
    loading = false,
    onChange,
    onApply,
    onReset
}) {
    return (
        <FilterToolboxShell loading={loading} onApply={onApply} onReset={onReset}>
            <label className="field">
                Recherche
                <input
                    type="search"
                    placeholder="Nom du lot, description ou produit"
                    value={filters.search}
                    onChange={(e) => onChange({ ...filters, search: e.target.value })}
                />
            </label>

            <label className="field field--status">
                Statut
                <select
                    value={filters.status}
                    onChange={(e) => onChange({ ...filters, status: e.target.value })}
                >
                    <option value="">Tous</option>
                    {LOT_STATUSES.map((status) => (
                        <option key={status} value={status}>{formatLotStatus(status)}</option>
                    ))}
                </select>
            </label>
        </FilterToolboxShell>
    );
}
